import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * The dashboard is a single page with its own tab bar, so it needs one route
 * ref. The tabs are plain paths below it (`dashboard`, `dependencies`,
 * `advisor`, `cost-insights`) and are navigated to relatively.
 */
export const rootRouteRef = createRouteRef();
